import { Admin, Resource } from 'react-admin';
import authProvider from '../Admin/Providers/Auth.provider';
import dataProvider from '../Admin/Providers/Data.provider';
import { translations } from '../i18n/i18n';
import polyglotI18nProvider from 'ra-i18n-polyglot';

import PhotoTypeResource from '../Admin/Resources/PhotoType.resource';
import ModelTypeResource from '../Admin/Resources/ModelType.resource';
import PlaceTypeResource from '../Admin/Resources/PlaceType.resource';
import PlacesResource from '../Admin/Resources/Place.resource';
import UsersResource from '../Admin/Resources/User.resource';
import { useEffect } from 'react';
import AuthOnlyAdmin from '../Admin/AuthOnlyAdmin.component';
import { Route } from 'react-router-dom';
import SettingsRoute from '../Admin/Routes/Settings.component';
import MenuComponent from '../Admin/Menu.component';

const customRoutes = [
	<Route path="/settings" component={SettingsRoute} />,
];

function AdminPage({ onInitialized }) {
	const i18nProvider = polyglotI18nProvider(locale => translations, translations.getLanguage());

	return (
		<AuthOnlyAdmin dataProvider={dataProvider} authProvider={authProvider} i18nProvider={i18nProvider} customRoutes={customRoutes} menu={MenuComponent} requireAuth>
        	<Resource name="places" {...PlacesResource} />
			<Resource name="placetypes" {...PlaceTypeResource} />
			<Resource name="phototypes" {...PhotoTypeResource} />
			{/*<Resource name="modeltypes" {...ModelTypeResource} />*/}
			<Resource name="users" {...UsersResource} />
    	</AuthOnlyAdmin>
	);
}
  
export default AdminPage;  